import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(15, 55, 91, .7), rgba(137, 175, 63, .9)',
    barImage: "/static/sidebar-1.png",
    drawer: null,
    instancia: '',
    current_url: 0,
    datetime: 0,
    avatar: undefined,
    files: [],
    pagos:0
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    SET_SCRIM(state, payload) {
      state.barColor = payload
    },
    updateFiles(state, files) {
      state.files = files
    }
  },
  actions: {

  },
})
